import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { PaperContent } from 'view/layout/paper';
import * as fonts from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';
import { DocumentTitle } from '@atlassian/help-center-common-component/document-title';
import { ThemedLink } from '@atlassian/help-center-common-component/themed-link';

interface Props {
    title: string;
    icon?: React.ComponentClass | React.FunctionComponent;
    header?: string;
    description?: string;
    callToActionHref?: string;
    callToActionText?: string;
    dataTestId?: string;
    actionHrefTarget?: '_blank' | '_self' | '_parent' | '_top';
}

const SimpleIconPage = ({
    actionHrefTarget,
    title,
    header,
    description,
    callToActionHref,
    callToActionText,
    dataTestId,
    icon: Icon,
}: Props) => {
    return (
        <DocumentTitle title={title}>
            <PaperContent>
                <Container data-testId={dataTestId}>
                    {!!Icon && <Icon />}
                    {!!header && <Message>{header}</Message>}
                    {!!description && <Description>{description}</Description>}
                    {!!callToActionHref && (
                        <Link to={callToActionHref} actionSubjectId="callToAction" target={actionHrefTarget}>
                            {callToActionText}
                        </Link>
                    )}
                </Container>
            </PaperContent>
        </DocumentTitle>
    );
};

export default SimpleIconPage;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Message = styled.div`
    ${fonts.h600};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Description = styled.p`
    ${fonts.regular};
    /* setting max-width 100% because on IE, text flows out of the container */
    max-width: 100%;
    margin: 0 0 ${token('space.100', '8px')} 0;
    text-align: center;
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Container = styled.div`
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    margin-top: ${token('space.600', '48px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Link = styled(ThemedLink)`
    text-align: center;
`;
